module.exports = __webpack_public_path__ + "static/img/3.028d389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newFive/3.png
// module id = jb0X
// module chunks = 0